import React, { FC } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import TextEditorPage from '../../pages/text-editor-page/TextEditorPage';
import StartPage from '../../pages/landing-page/start-page/StartPage';
import PrivacyPolicy from '../../pages/privacy-page/PrivacyPage';
import TermsOfService from '../../pages/terms-of-use-page/TermsOfUsePage';
import EulaPage from '../../pages/eula-page/EulaPage';
import ImageEditorPage from '../../pages/image-editor-page/ImageEditorPage';
import AuthPage from '../../pages/auth-page/AuthPage';
import DashboardPage from '../../pages/dashboard-page/DashboardPage';
import CreatePostPage from '../../pages/create-post-page/CreatePostPage';
import AboutPage from '../../pages/landing-page/about-page/AboutPage';
import SolutionPage from '../../pages/landing-page/solution-page/SolutionPage';
import ContactPage from '../../pages/landing-page/contact-page/ContactPage';
import CreativityPage from '../../pages/landing-page/creativity-page/CreativityPage';
import BrandAnalyticsPage from '../../pages/landing-page/brand-analytics-page/BrandAnalyticsPage';
import TeamworkPage from '../../pages/landing-page/teamwork-page/TeamworkPage';
import VersionControlPage from '../../pages/landing-page/version-control-page/VersionControlPage';
import ApprovalProcessPage from '../../pages/landing-page/approval-page/ApprovalProcessPage';
import ResetPasswordPage from '../../pages/reset-password-page/ResetPasswordPage';
import PricingPage from '../../pages/landing-page/pricing-page/PricingPage';
import RegistrationPage from '../../pages/login-page/LoginPage';
import OnboardingPage from '../../pages/landing-page/onboarding-page/OnboardingPage';
import { motion } from 'framer-motion';
import ReadyPostPage from '../../pages/ready-post-page/ReadyPostPage';
import CustomPostPage from '../../pages/custom-post-page/CustomPostPage';
import PublishedPostPage from '../../pages/landing-page/published-post-page/PublishedPostPage';
import CreatePost from '../../pages/create-post-page/CreatePost';
import SettingPage from '../../pages/setting-page/SettingPage';
import SchedulePage from '../../pages/schedule-page/SchedulePage';
import ThreeSimilarPostsPage from '../../pages/three-similar-posts-page/ThreeSimilarPostsPage';
import GenerateQuickPostPage from '../../pages/generate-quick-post-page/GenerateQuickPostPage';

const RoutesConfig: FC = () => {
    const location = useLocation();
    return (
        <Routes location={location} key={location.pathname}>
            <Route path="/ready-post/:projectId" element={<ReadyPostPage />} />
            <Route path="/published-post/:projectId" element={<PublishedPostPage />} />
            <Route path="/custom-post/:projectId" element={<CustomPostPage />} />
            <Route path="/generate-quick-post/:platform" element={<GenerateQuickPostPage />} />
            <Route path="/multiple-posts/:projectId" element={<ThreeSimilarPostsPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/settings" element={<SettingPage />} />
            <Route path="/create-post/:projectId" element={<CreatePost />} />
            <Route path="/text_project/:projectId" element={<TextEditorPage />} />
            <Route path="/image_project/:projectId" element={<ImageEditorPage />} />

            <Route path="/login" element={<RegistrationPage />} />
            <Route
                path="/onboarding"
                element={
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.2 }}
                        style={{ width: '100%' }}
                    >
                        <OnboardingPage />
                    </motion.div>
                }
            />
            <Route path="/" element={<StartPage />} />
            <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
            <Route path="/terms-of-use" element={<TermsOfService />} />
            <Route path="/eula" element={<EulaPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/eula" element={<EulaPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/features" element={<SolutionPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/creativity" element={<CreativityPage />} />
            <Route path="/brand-analytics" element={<BrandAnalyticsPage />} />
            <Route path="/teamwork" element={<TeamworkPage />} />
            <Route path="/version-control" element={<VersionControlPage />} />
            <Route path="/approval-process" element={<ApprovalProcessPage />} />
            <Route path="/pricing" element={<PricingPage />} />
        </Routes>
    );
};

export default RoutesConfig;
